// Legal Notice, EN version
// Markers [TO BE COMPLETED] are kept verbatim, italicised by ReactMarkdown.

const legalNoticesEn = `# Legal Notice

*Last updated: May 13, 2026*

---

## 1. Site Publisher

The website **beyondpersonalmatrix.com** (hereinafter "the Site") is published by:

**BPM**, a Simplified Joint-Stock Company (Société par Actions Simplifiée) under French law, with a share capital of €1,000
Registered office: 73, Rue du Château, 92100 BOULOGNE-BILLANCOURT (France)
Registered with the Trade and Companies Register (RCS) of NANTERRE
SIREN: 987 605 567
SIRET (registered office): 987 605 567 000 14
EU VAT number: FR86987605567

**Publication Director**: *[TO BE COMPLETED, presumably Gilles IACONES, President of BPM]*

**Contact**:
Email: support@beyondpersonalmatrix.com

The Site operates the commercial service **Beyond Personal Matrix** (hereinafter "the Service").

---

## 2. Hosting

The Site is hosted by:

**Emergent** *(Emergent Methods, Inc., address to be completed according to the Emergent Terms of Service in force)*
*[TO BE COMPLETED: postal address and exact contact details of the host to be retrieved from Emergent documentation]*

The domain name is registered with **Namecheap, Inc.** (4600 East Washington Street, Suite 305, Phoenix, AZ 85034, United States).

---

## 3. Intellectual Property

All elements composing the Site (texts, graphics, logos, icons, images, videos, sounds, as well as their layout) are the exclusive property of BPM or are subject to a license for use. Any reproduction, representation, modification, publication, total or partial adaptation of the elements of the Site, by any means or process, is prohibited without the prior written authorization of BPM.

The brand "**Beyond Personal Matrix**" is used by BPM as a trade name. Any unauthorized use of the trade name, logo, or distinctive elements of the Service may engage the responsibility of its author.

The psychometric content used (DISC, Big Five, MBTI, Enneagram, VIA Strengths, Schwartz Values) is based on public scientific models and is implemented in versions adapted by BPM.

---

## 4. Personal Data

The processing of users' personal data is governed by the **Privacy Policy** available at: [beyondpersonalmatrix.com/privacy](https://beyondpersonalmatrix.com/privacy).

To exercise your rights regarding your personal data, you can write to: privacy@beyondpersonalmatrix.com.

---

## 5. Cookies

The use of cookies on the Site is regulated by the cookie policy presented during your first visit. You can modify your preferences at any time via the cookie management banner.

---

## 6. Limitation of Liability

BPM makes every effort to ensure the accuracy and updating of information disseminated on the Site. However, BPM cannot guarantee the accuracy, precision, or completeness of the information made available on the Site.

The results of psychometric tests provided by the Service are produced using algorithms and artificial intelligence models. These results are intended for **informational and personal development purposes** and cannot in any way replace professional medical, psychological, or psychiatric advice.

BPM cannot be held responsible for:
- direct or indirect damages resulting from the use of the Site;
- any interruptions or unavailability of the Site due to maintenance operations or force majeure;
- decisions made by users based on the results provided by the Service.

---

## 7. Applicable Law and Jurisdiction

These legal notices are governed by French law. In the event of a dispute, and after an amicable resolution attempt, the French courts shall have sole jurisdiction in accordance with the applicable rules of jurisdiction.

In accordance with the provisions of Articles L.611-1 et seq. of the French Consumer Code, consumers may use the following mediation service free of charge:
*[TO BE COMPLETED: name and contact details of the consumer mediator to which BPM adheres. Legal obligation for B2C e-commerce. Common mediators in France: CNPM-Médiation, MEDICYS, Devigny Médiation, etc.]*

Consumers may also use the European Online Dispute Resolution platform: [ec.europa.eu/consumers/odr](https://ec.europa.eu/consumers/odr).
`;

export default legalNoticesEn;
